import * as React from "react";
import styled from "@emotion/styled";
import { User, Settings, LogOut, Sun, Moon } from "react-feather";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

import {
  Tooltip,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
  Avatar,
  Box,
  Typography,
  Divider,
} from "@mui/material";

import useAuth from "../../hooks/useAuth";
import useAppTheme from "../../hooks/useTheme";
import { THEMES } from "../../constants";

const StyledIconButton = styled(MuiIconButton)`
  padding: 4px;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
  border: 2px solid transparent;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
    border: 2px solid ${(props) => props.theme?.palette?.primary?.main || "#1976d2"};
  }
`;

const StyledAvatar = styled(Avatar)`
  width: 38px;
  height: 38px;
  background: linear-gradient(
    135deg,
    ${(props) => props.theme?.palette?.primary?.main || "#1976d2"} 0%,
    ${(props) => props.theme?.palette?.primary?.dark || "#115293"} 100%
  );
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

const StyledMenuItem = styled(MenuItem)`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.9rem;

  svg {
    color: ${(props) => props.theme?.palette?.text?.secondary || "#666"};
  }

  &:hover {
    svg {
      color: ${(props) => props.theme?.palette?.primary?.main || "#1976d2"};
    }
  }
`;

function NavbarUserDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState(null);
  const navigate = useNavigate();
  const { signOut, user } = useAuth();
  const muiTheme = useTheme();
  const { theme: currentTheme, setTheme } = useAppTheme();
  const isDarkMode = currentTheme === THEMES.DARK || muiTheme.palette.mode === "dark";

  console.log(user, "user90878");

  const toggleMenu = (event) => {
    setAnchorMenu(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorMenu(null);
  };
  const handleSettings = async () => {
    setAnchorMenu(null);
    navigate("/cpanel/tenant/general-setting", { state: { id: user?.tenantId } });
  };

  const handleToggleTheme = () => {
    closeMenu();
    if (isDarkMode) {
      setTheme(THEMES.DEFAULT);
    } else {
      setTheme(THEMES.DARK);
    }
  };

  const handleSignOut = async () => {
    await signOut();
    navigate("/auth/sign-in");
  };

  // Helper to get initials
  const getInitials = (name) => {
    if (!name) return "";
    return name.charAt(0).toUpperCase();
  };

  return (
    <React.Fragment>
      <Tooltip title="Account">
        <StyledIconButton
          aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="small"
        >
          <StyledAvatar>{user?.name ? getInitials(user.name) : <User size={20} />}</StyledAvatar>
        </StyledIconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
        PaperProps={{
          elevation: 3,
          sx: {
            mt: 1.5,
            minWidth: 200,
            borderRadius: 2,
            overflow: "visible",
            filter: "drop-shadow(0px 4px 20px rgba(0,0,0,0.1))",
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box sx={{ px: 2.5, py: 1.5 }}>
          <Typography variant="subtitle1" fontWeight="600" noWrap>
            {user?.name || "User"}
          </Typography>
          <Typography variant="body2" color="text.secondary" noWrap>
            {user?.email || user?.userName || "Admin"}
          </Typography>
        </Box>
        <Divider sx={{ my: 0.5 }} />
        <StyledMenuItem onClick={closeMenu}>
          <User size={18} />
          Profile
        </StyledMenuItem>
        <StyledMenuItem onClick={handleToggleTheme}>
          {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
          {isDarkMode ? "Light Mode" : "Dark Mode"}
        </StyledMenuItem>
        {user && user.businessType == "MULTI_SERVICE_OPERATOR" && (
          <StyledMenuItem onClick={handleSettings}>
            <Settings size={18} />
            Settings
          </StyledMenuItem>
        )}
        <Divider sx={{ my: 0.5 }} />
        <StyledMenuItem onClick={handleSignOut} sx={{ color: "error.main" }}>
          <LogOut size={18} style={{ color: "inherit" }} />
          Sign out
        </StyledMenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default NavbarUserDropdown;
